import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorContent from '@/pages/Errors/components/ErrorContent';
import { ROUTES } from '@/utils/constants/routesConstants';

const ErrorBoundary = ({ children, onGoHome }) => {
  const [hasError, setHasError] = useState(false);
  const [, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleError = (errorEvent) => {
      console.error('ErrorBoundary caught an error:', errorEvent.error);
      setError(errorEvent.error);
      setHasError(true);
    };

    const handleUnhandledRejection = (event) => {
      console.error('ErrorBoundary caught an unhandled promise rejection:', event.reason);
      setError(event.reason);
      setHasError(true);
    };

    // Add global error listeners
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    // Cleanup listeners on unmount
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  const handleGoHome = () => {
    if (onGoHome) {
      onGoHome();
    } else {
      navigate(ROUTES.HOME);
      window.location.reload();
    }
  };

  if (hasError) {
    return (
      <ErrorContent
        errorType="SERVER_ERROR"
        onGoHome={handleGoHome}
      />
    );
  }

  return children;
};

export default ErrorBoundary; 